module.exports = __webpack_public_path__ + "img/1618408173.3befbf54.png";